
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.258 4.836c0 .98.104 1.617.312 1.914.209.292.547.438 1.016.438.375 0 .753-.185 1.133-.555.385-.37.578-.784.578-1.242V.523H6.64v5.86c0 .61.187.914.562.914.23 0 .474-.11.734-.328l.305.468c-.547.454-1.094.68-1.64.68-.776 0-1.198-.445-1.266-1.336l-.07-.023c-.787.875-1.537 1.312-2.25 1.312-.396 0-.75-.15-1.063-.453l-.062.047c.088 1.037.221 1.899.398 2.586v.43l-.68.453H.914V.53h1.344v4.305z","fill":"currentColor"}})])
          )
        }
      }
    